import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=4aa5993e&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5993e",
  null
  
)

export default component.exports